var PAGE_TEXT_DELIMITER = ': ';


/**
 * Helper for parsing the text found in V3 UTR notes ( page text )
 * Now not using as an Object -- but in just a functional manner -- could change to have state.
 * Values come from the src our highlight note array in the form: "FDDPage 2: Lorem Ipsum...";
 * Can't use split on the page text in case there's another ": "
 */


module.exports = {

    getPageNumberAndText: function( rawText ) {

        var delimiterIndex = rawText.indexOf( PAGE_TEXT_DELIMITER );
        var pageDelimiter = rawText.substring( 0, delimiterIndex );

        return {
            pgNumber: parseFloat( pageDelimiter.split(' ')[1] ),
            pgText: this.getPageText( rawText, delimiterIndex )
        };

    },

    getPageText: function( rawText, delimiterIndex ) {

        delimiterIndex = delimiterIndex || rawText.indexOf( PAGE_TEXT_DELIMITER );

        return rawText.substring( delimiterIndex + PAGE_TEXT_DELIMITER.length );

    }

};







/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/esModel/utrNoteVersion3TextParser.js
 ** module id = 404
 ** module chunks = 0
 **/